export default __webpack_public_path__ + "static/media/gap.f22c12ce.less";